/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-use-before-define, max-len */
import Axios, {
  AxiosInstance,
  AxiosResponse,
} from 'axios';
import { resumeParser } from './configuration';
/**
 * Requests
 */
class ResumeMatchServiceRequests {
  static client: ResumeMatchServiceRequests;

  axios: AxiosInstance;

  constructor() {
    this.axios = Axios.create({
      baseURL: process.env.REACT_APP_RESUME_MATCH_SERVICES_API,
    });
    this.axios.defaults.timeout = 35000;
  }

  static getInstance = () => {
    if (!ResumeMatchServiceRequests.client) {
      ResumeMatchServiceRequests.client = new ResumeMatchServiceRequests();
    }
    return ResumeMatchServiceRequests.client;
  };

  updateSkills = (payload: any) => this.axios.post(resumeParser.updateSkills, payload).then(
    (response: AxiosResponse<any>) => response.data,
  );
}

export default ResumeMatchServiceRequests;
